import React, { useContext, useEffect, useState } from 'react';

import { Logout } from '../../config/modules/helpers';

import P from 'prop-types';
import Cookies from 'js-cookie';

import SwitchCheckbox from '../Forms/SwitchCheckbox';
import Swal from 'sweetalert2';
import { AuthContext } from '../../config/context/AuthContext';
import If from '../../common/IF';
import { Link } from 'react-router-dom';
const NavBar = (props) => {
  const { setThemeDark, themeDark } = props;
  const darkmode = Cookies.get('dark-mode');
  const [buttonDark, setButtonDark] = useState(false);
  const ctxAuth = useContext(AuthContext);

  /** load theme */
  useEffect(() => {
    var body = document.getElementsByTagName('body');
    let checkboxDark = document.getElementById('darkmode');
    if (darkmode) {
      body[0].classList.add('dark-mode');
      setButtonDark(false);
      setThemeDark(true);
      if (checkboxDark) {
        checkboxDark.checked = true;
      }
    } else {
      body[0].classList.remove('dark-mode');
      setButtonDark(false);
      setThemeDark(false);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [darkmode, buttonDark]);

  const handleDarkChange = (e) => {
    if (e) {
      setButtonDark(true);
      Cookies.set('dark-mode', true, { expires: 30, path: '/' });
    } else {
      setButtonDark(true);
      Cookies.remove('dark-mode');
    }
  };

  return (
    <>
      <nav
        className={`main-header navbar navbar-expand text-sm ${
          themeDark ? ' navbar-dark' : ' navbar-light navbar-white'
        }`}
      >
        {/* Left navbar links */}
        <ul className='navbar-nav'>
          <li className='nav-item'>
            <a className='nav-link' data-widget='pushmenu' href='/#' role='button'>
              <i className='fal fa-bars'></i>
            </a>
          </li>
        </ul>
        {/* <ul className='navbar-nav ml-auto'>
          <li className='nav-item d-sm-inline-block'>
            <span className='text-sm text-info>'>{formattedDate}</span>
          </li>
        </ul> */}
        {/* Right navbar links */}
        <ul className='navbar-nav ml-auto'>
          <li className='nav-item d-none d-sm-inline-block'>
            <a href='/' className='nav-link'>
              Home
            </a>
          </li>
          {/* dropdown suporte */}
          {/* <li className='nav-item dropdown d-none d-sm-inline-block'>
            <a href='/#' className='nav-link dropdown-toggle' data-toggle='dropdown'>
              Suporte
            </a>
            <div className='dropdown-menu dropdown-menu-lg dropdown-menu-right'>
              <span className='dropdown-item dropdown-header'>
                {' '}
                {ctxAuth?.adm || ctxAuth?.userData?.suport ? 'Painel' : 'Suporte'}
              </span>
              <div className='dropdown-divider'></div>
              <Link to='/v1/tickets' className='dropdown-item'>
                <i className='fas fa-ticket-alt mr-2'></i>{' '}
                {ctxAuth?.adm || ctxAuth?.userData?.suport ? 'Atender Chamados' : 'Abrir Chamado'}
              </Link>

              <div className='dropdown-divider'></div>
              <If condition={ctxAuth?.adm ? true : false}>
                <Link to='/v1/tickets/types' className='dropdown-item'>
                  <i className='fas fa-gear mr-2'></i> Tipos de Tickets
                </Link>

                <Link to='/v1/tickets/subtypes' className='dropdown-item'>
                  <i className='fas fa-gear mr-2'></i> Subtipos de Tickets
                </Link>
              </If>
              <div className='dropdown-divider'></div>
              <a href='/#' className='dropdown-item'>
                <i className='fas fa-file mr-2'></i> FAQ&apos;s
              </a>
            </div>
          </li> */}

          <li className='nav-item d-none d-sm-inline-block'>
            <button
              type='button'
              className={`btn btn-flat nav-link btn-muted`}
              title={'Logout'}
              onClick={() => {
                Swal.fire({
                  title: 'Logout',
                  text: 'Deseja realmente sair do sistema?',
                  icon: 'warning',
                  showCancelButton: true,
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#d33',
                  confirmButtonText: 'Sim',
                  cancelButtonText: 'Nao',
                }).then((r) => {
                  if (r.isConfirmed) {
                    Logout();
                  }
                });
              }}
            >
              Sair
            </button>
          </li>
        </ul>
        <ul className='navbar-nav ml-2'>
          <li className='nav-item d-flex text-sm '>
            <SwitchCheckbox
              id={'darkmode'}
              defaultChecked={themeDark}
              event={handleDarkChange}
              label={'Dark-mode'}
              color={'info'}
              size={'sm'}
            />
          </li>
        </ul>
      </nav>
      <div
        id='logoutButton'
        className={'modal modal-center fade overflow-auto'}
        size='md'
        title={'Logout'}
      >
        <div className={`modal-dialog modal-dialog-centered`}>
          <div className={`modal-content`}>
            <div className='modal-header'>
              <h4 className={`modal-title `}>Logout</h4>
            </div>
            <div className='modal-body'>
              <div className='row'>
                <div className='col-12'>
                  <div className='card d-flex flex-column '>
                    <div className=' card-body text-center'>
                      <p>Deseja realmente sair do sistema?</p>
                    </div>
                    <div className='d-flex justify-content-space-between p-1'>
                      <div className='col-md-6'>
                        <button
                          type='button'
                          onClick={() => Logout()}
                          className='btn  btn-danger btn-block'
                        >
                          Sair
                        </button>
                      </div>
                      <div className='col-md-6'>
                        <button
                          type='button'
                          className='btn btn-default btn-block '
                          data-dismiss='modal'
                        >
                          Cancelar
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NavBar;
NavBar.propTypes = {
  setThemeDark: P.func,
  themeDark: P.bool,
};
